<template>
  <div class="app">
    <router-view :key="key" />
  </div>
</template>

<script>
export default {
  computed: {
    key() {
      return this.$route.path
    }
  },
  // 监听函数
  watch: {
    $route(newVal, oldVal) {
      // console.log(newVal)
      // console.log(oldVal)
      // console.log('用watch监听路由变化，我们的路由一定要有子路由，监听变化也紧局限在父子路由中')
      if (newVal.fullPath === '/main?user=true') {
        // this.$router.go(0)
      }
    }
  }
}
</script>

<style></style>
